(function() {
  const stickyBar = document.getElementById('pdStickyBar');
  const heroSection = document.getElementById('pd-hero');
  if (stickyBar && heroSection) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          stickyBar.classList.add('is-visible');
        } else {
          stickyBar.classList.remove('is-visible');
        }
      });
    }, { threshold: 0 });
    observer.observe(heroSection);
  }

  function updateStickyCart() {
    const selectedCard = document.querySelector('.js-bundle-card.selected');
    if (!selectedCard) return;

    const stickyTitle = document.getElementById('pdStickyTitle');
    const stickyPrice = document.getElementById('pdStickyPrice');
    const stickyCompare = document.getElementById('pdStickyComparePrice');
    const stickyImg = document.getElementById('pdStickyImg');

    const titleEl = selectedCard.querySelector('.pd-hero__bundle-title');
    const priceEl = selectedCard.querySelector('.pd-hero__bundle-price');
    const compareEl = selectedCard.querySelector('.pd-hero__bundle-compare');
    const imgEl = selectedCard.querySelector('img');

    if (stickyTitle && titleEl) {
      stickyTitle.textContent = titleEl.textContent.trim();
    }
    if (stickyPrice && priceEl) {
      stickyPrice.textContent = priceEl.textContent.trim();
    }
    if (stickyCompare) {
      if (compareEl && compareEl.textContent.trim()) {
        stickyCompare.textContent = compareEl.textContent.trim();
        stickyCompare.style.display = 'inline';
      } else {
        stickyCompare.style.display = 'none';
      }
    }
    if (stickyImg && imgEl && imgEl.src) {
      stickyImg.src = imgEl.src;
    }
  }

  document.addEventListener('nu:variant-changed', updateStickyCart);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateStickyCart);
  } else {
    updateStickyCart();
  }

  const stickyBtn = document.getElementById('pdStickyBtn');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', (e) => {
      e.preventDefault();
      stickyBtn.innerText = 'Redirecting...';
      stickyBtn.style.opacity = '0.7';
      stickyBtn.style.pointerEvents = 'none';

      const vId = window.nuActiveVariant || window.nuMainVariantId;
      const qty = parseInt(window.nuActiveQuantity || 1);
      const activeId = document.documentElement.getAttribute('data-nu-campaign') || (window.NuSeasonalCampaign && window.NuSeasonalCampaign.activeId);
      const camp = window.NuSeasonalCampaign && window.NuSeasonalCampaign.campaigns && window.NuSeasonalCampaign.campaigns[activeId];
      let checkoutUrl = '/checkout';
      if (camp && camp.couponCode && camp.eligibleVariants && camp.eligibleVariants.includes(String(vId))) {
        checkoutUrl = '/checkout?discount=' + encodeURIComponent(camp.couponCode);
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: vId, quantity: qty })
      }).then(() => {
        window.location.href = checkoutUrl;
      }).catch(err => {
        console.error(err);
        window.location.href = '/cart/' + vId + ':' + qty;
      });
    });
  }
})();
